export const TOPUP_CONFIG = {
  topupAmountMin: 0.01,
  topupAmountMax: 600
}
